import React from 'react';

export const Accessibility = ({ height="33px", width="26x",padding="12px",style=''})=> (
    <svg className = "chatLanding-support-XA3-item-grid-image" role="presentation" aria-label="" padding={padding} viewBox="0 0 26 33" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="Symbols" stroke="none" strokeWidth="1" fill="rgb(97, 56, 245)" fillRule="evenodd">
            <path  d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18.5A8.5,8.5,0,1,1,20.5,12,8.51,8.51,0,0,1,12,20.5ZM10.86,7.13a1.16,1.16,0,1,1,1.37.9A1.17,1.17,0,0,1,10.86,7.13ZM13.28,9.8v2.94l1.46,5.37-1.21.32-1.41-5.2H11.8l-1.41,5.2-1.21-.32,1.54-5.68V9.8L6.63,9.24,6.8,8l4,.56h2.47L17.2,8l.17,1.24-4,.56Z" />
        </g>
    </svg>
);
